var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92938 20.7434C4.94783 20.2124 3.7719 18.1757 4.30285 16.1941C4.41006 15.794 4.17262 15.3828 3.77252 15.2756C3.37242 15.1683 2.96117 15.4058 2.85396 15.8059C2.10859 18.5876 3.75941 21.4469 6.54115 22.1923C6.94125 22.2995 7.3525 22.0621 7.45971 21.662C7.56692 21.2619 7.32948 20.8506 6.92938 20.7434Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9614 20.7434C18.9429 20.2124 20.1189 18.1757 19.5879 16.1941C19.4807 15.794 19.7181 15.3828 20.1182 15.2756C20.5183 15.1683 20.9296 15.4058 21.0368 15.8059C21.7822 18.5876 20.1313 21.4469 17.3496 22.1923C16.9495 22.2995 16.5382 22.0621 16.431 21.662C16.3238 21.2619 16.5613 20.8506 16.9614 20.7434Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67618 5.86243C7.74484 5.36805 8.16754 5 8.66667 5H15.3333C15.8325 5 16.2552 5.36805 16.3238 5.86243L17.9905 17.8624C18.0303 18.1489 17.9441 18.4386 17.7542 18.6567C17.5643 18.8748 17.2892 19 17 19H7C6.71079 19 6.43574 18.8748 6.24582 18.6567C6.05591 18.4386 5.96972 18.1489 6.00951 17.8624L7.67618 5.86243ZM9.53738 7L8.14849 17H15.8515L14.4626 7H9.53738Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5C15 19.3284 14.3284 20 13.5 20C12.6716 20 12 19.3284 12 18.5C12 17.6716 12.6716 17 13.5 17C14.3284 17 15 17.6716 15 18.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C11.4477 4 11 4.44772 11 5H9C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5H13C13 4.44772 12.5523 4 12 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOn);
export default __webpack_public_path__ + "static/media/notification-on.c62f70c52f30d1dfd0c4eaf010893b4c.svg";
export { ForwardRef as ReactComponent };